import moment, {Moment} from "moment";
import * as lodash from "lodash";
import {getLocalTimezone} from "../../services/app";
import ScheduleParser from "../../services/schedule";

moment.updateLocale('en', {week: {dow: 1,}});
const dateFormat = 'MM/DD/YYYY';


export const getLocalDateId = (date) => {
    return parseInt(date.format("YYYYMMDD"));
}

export const dateRangeToArray = (from, to) => {
    const result = [];
    let start = from.toDate();
    let end = to.toDate();
    let time = [];
    for (let i = 0; i < 24; i++) {
        time.push({
            id: i,
            tasks: []
        })
    }

    while (start < end) {
        result.push({
            id: getLocalDateId(moment(start)),
            date: moment(start),
            time: time
        });
        let newDate = start.setDate(start.getDate() + 1);
        start = new Date(newDate);
    }
    return result
}

export const convertTime = (timeStr) => {
    return parseInt(timeStr.split(':')[0]) + parseInt(timeStr.split(':')[1] || '0') / (60 * 1.0);
}
export const reconvertTime = (timeNum) => {
    const text = (x) => x >= 10 ? x : `0${x}`;
    let hour = parseInt(timeNum.toString().split('.')[0]);
    hour = hour >= 24 ? 0 : hour;
    const min = Math.round(parseFloat("0." + (timeNum.toString().split('.')[1] || "0")) * 60);
    return `${text(hour)}:${text(min)}`;
}

export const reconvertTime2 = (timeNum) => {
    let timeSlot = "AM";
    if (timeNum >= 12) {
        timeSlot = "PM";
    }
    if (timeSlot === 'AM' && timeNum === 0) {
        timeNum = 12;
    }
    const text = (x) => x >= 10 ? x : `0${x}`;
    const hour = parseInt(timeNum.toString().split('.')[0]);
    const min = Math.round(parseFloat("0." + (timeNum.toString().split('.')[1] || "0")) * 60);
    return `${text(hour)}:${text(min)} ${timeSlot}`;
}

export const getChanged = (dataNew, dataOld) => {
    const changed = {};
    const keys = Object.keys({...dataOld, ...dataNew});
    keys.map(dataKey => {
        const newValue = dataNew[dataKey];
        const oldValue = dataOld[dataKey];
        if (!lodash.isEqual(newValue, oldValue)) {
            changed[dataKey] = newValue;
        }
    })
    return changed;
}

export const formatSchedules = (schedules, startDate = null, endDate = null) => {
    let slots = [];
    // @ts-ignore
    window.ScheduleParser = ScheduleParser;
    window.moment = moment;
    for (let i = 0; i < schedules.length; i++) {
        let localTimezone = getLocalTimezone();
        const schedule = ScheduleParser(schedules[i], {
            configScheduleTimezone: localTimezone, // Timezone of schedule đầu vào
            currentTimeZone: localTimezone, // Timezone của client request
            startDate: startDate,
            endDate: endDate,
        });
        slots = [...slots, ...schedule.getLegacySlots()];
    }
    return slots.filter(x => !x.isOtherSlot);
}

export const formatSchedulesAsync = (schedules: Array<any>, startDate = null, endDate = null, delayTime = 0): Promise<any> => {
    // delayTime for waiting animation loading
    console.log('formatSchedulesAsync', delayTime + 'ms',schedules);
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(formatSchedules(schedules, startDate, endDate));
        }, delayTime || 0);
    })
}

export const getNextSchedule = (schedulesArr, momentDate) => {
    const sorted = schedulesArr.sort((a, b) => a.id > b.id ? 1 : (a.id < b.id ? -1 : 0));
    return sorted.filter(x => x.id >= getLocalDateId(momentDate))[0];
}


export const getCalenderMonthStartAndEnd = (currentMonth: Moment) => {
    const startOfMonth = currentMonth.clone().startOf('month');
    const endOfMonth = startOfMonth.clone().endOf('month');
    const startOfWeek = startOfMonth.clone().startOf('isoWeek');
    const endOfWeek = endOfMonth.clone().endOf('isoWeek')
    return {
        startMonth: startOfWeek.clone(),
        endMonth: endOfWeek.clone(),
    };
}